import { OptionProps } from 'components/Common/Form/Select';

export enum Types {
	CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA',
	CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_SUCCESS = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_SUCCESS',
	CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_FAILURE = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_FAILURE',
	CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_CLEAR = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_CLEAR',
}

export interface ConsultarParametroLocalidadesSigla {
	status: number;
	data: ParametroLocalidadeData | null;
	enum: OptionProps[];
	totalRegistrosConsulta: number;
}

export interface ParametroLocalidadeData {
	localidades: LocalidadesAssociadaSigla[];
	sigla: string;
	descricao: string;
}

export interface ConsultarParametroLocalidadesSiglaRequest {
	sigla: string;
	idOrgao?: number;
}

export interface LocalidadesAssociadaSigla {
	idLocalidade: number | string;
	nomeLocalidade: string;
	idParametro: number | string;
	valorParametro: string;
	valor: string;
	key?: string;
	idOrgao: string;
}
